// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveInstitutionDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import InstitutionDTO from '../models/InstitutionDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    institutionId: string | null | null;
    institution: InstitutionDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            institutionId: null,
            institution: null,
        },
        initValues);
    },
    institutionId: 'institutionId',
    institution: 'institution',
}

interface Result extends ResultDTO {
    institution: InstitutionDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            institution: null,
        },
        initValues);
    },
    institution: 'institution',
}

export { Request, Result };